module.exports = __webpack_public_path__ + "img/73814a5.svg";